import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getConsumptionSourceList,
	addNewConsumptionSource,
	updateConsumptionSource,
	deleteConsumptionSource,
	getConsumptionSource,
	getConsumptionSourceByCode,
} from '../consumptionSource/thunk';

export const initialState = {
	itemConsumptionSourceList: [],
	itemConsumptionSourceDetail: null,
	isConsumptionSourceLoading: false,
	isConsumptionSourceSuccess: false,

	consumptionSourceList: [],
	consumptionSourceListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ConsumptionSourceSlice = createSlice({
	name: 'ConsumptionSource',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getConsumptionSource.fulfilled, (state, action) => {
			state.isConsumptionSourceLoading = false;
			state.isConsumptionSourceSuccess = true;
			state.itemConsumptionSourceDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getConsumptionSource.pending, state => {
			state.isConsumptionSourceLoading = true;
			state.isConsumptionSourceSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getConsumptionSource.rejected, (state, action) => {
			state.isConsumptionSourceLoading = false;
			state.isConsumptionSourceSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

  

		builder.addCase(getConsumptionSourceList.pending, state => {
			state.isConsumptionSourceSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getConsumptionSourceList.fulfilled, (state, action) => {
			state.itemConsumptionSourceList = action.payload;
			state.consumptionSourceList = action.payload;
			state.isLoadingList = false;
			state.isConsumptionSourceSuccess = true;

			let consumptionSourceListSelect = [];
			action.payload.map(item =>
				consumptionSourceListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.consumptionSourceListSelect = consumptionSourceListSelect;
		});
		builder.addCase(getConsumptionSourceList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isConsumptionSourceSuccess = true;
		});
		builder.addCase(addNewConsumptionSource.fulfilled, (state, action) => {
			state.itemConsumptionSourceList.push(action.payload);
			state.consumptionSourceList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewConsumptionSource.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewConsumptionSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateConsumptionSource.fulfilled, (state, action) => {
			state.itemConsumptionSourceList = state.itemConsumptionSourceList.map(consumptionSource =>
				consumptionSource.consumptionSourcename === action.payload.old_consumptionSource
					? { ...consumptionSource, ...action.payload.updated_consumptionSource }
					: consumptionSource
			);
			state.consumptionSourceList = state.consumptionSourceList.map(consumptionSource =>
				consumptionSource._id.toString() === action.payload._id.toString()
					? { ...consumptionSource, ...action.payload }
					: consumptionSource
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateConsumptionSource.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateConsumptionSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteConsumptionSource.fulfilled, (state, action) => {
			state.itemConsumptionSourceList = current(state.itemConsumptionSourceList).filter(
				item => item._id !== action.payload._id
			);
			state.consumptionSourceList = current(state.consumptionSourceList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteConsumptionSource.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteConsumptionSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ConsumptionSourceSlice.actions;

export default ConsumptionSourceSlice.reducer;
